/* eslint-disable react/react-in-jsx-scope */
import React, { useState, useEffect } from 'react';
import Loading from 'src/components/UI/Loading';

const PrivacyPolicy = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="job-application-form">
      <div className="bg_Div mt-2 d-flex flex-column">
        <div className="show-stock">
          <div className="row">
            <div className="login-form" id="printTermsOfUse">
              <h2 className="labelName">Privacy Policy</h2>

              <div className="BodyDivPadding">

                <strong className="TROUSStrong">
                  Blazor Media Toolkit Campaign Guidelines
                </strong>

                <p className="TROUSParagraph">
                  Blazor Media Toolkit is platform for campaigns for products, brands
                  promotion to increase reach and content value for the purpose of business
                  promotion as well messaging and notifications platform.
                </p>
              
                <p className="TROUSParagraph">
                  By creating or publishing a campaign through BMT, users are
                  responsible for ensuring that their campaign information, promotional
                  content, images, videos, pricing, offers, and other campaign materials
                  are accurate and suitable for publication.
                </p>

                <strong className="TROUSStrong underline">
                  Campaigns must not contain:
                </strong>

                <ul>
                  <li>
                    <p className="TROUSParagraph">
                      False, misleading, deceptive, or inaccurate information about a
                      product, service, business, offer, promotion, or organization.
                    </p>
                  </li>

                  <li>
                    <p className="TROUSParagraph">
                      Promotional claims that cannot reasonably be supported or verified.
                    </p>
                  </li>

                  <li>
                    <p className="TROUSParagraph">
                      Misleading discounts, prices, offers, availability, expiration
                      dates, or promotional conditions.
                    </p>
                  </li>

                  <li>
                    <p className="TROUSParagraph">
                      Campaign content that intentionally hides important terms,
                      conditions, restrictions, or additional charges.
                    </p>
                  </li>

                  <li>
                    <p className="TROUSParagraph">
                      Content that impersonates another business, organization, brand,
                      or individual.
                    </p>
                  </li>

                  <li>
                    <p className="TROUSParagraph">
                      Campaigns created for fraudulent, deceptive, or unauthorized
                      promotional activities.
                    </p>
                  </li>

                  <li>
                    <p className="TROUSParagraph">
                      Content that promotes illegal products, services, or activities.
                    </p>
                  </li>

                  <li>
                    <p className="TROUSParagraph">
                      Hate speech, harassment, threats, abusive language, or content
                      targeting individuals or groups.
                    </p>
                  </li>

                  <li>
                    <p className="TROUSParagraph">
                      Content that promotes violence or encourages harmful activities.
                    </p>
                  </li>

                  <li>
                    <p className="TROUSParagraph">
                      Spam campaigns or campaigns created primarily to distribute
                      unwanted or repetitive promotional content.
                    </p>
                  </li>

                  <li>
                    <p className="TROUSParagraph">
                      Content that violates applicable laws, regulations, or third-party
                      rights.
                    </p>
                  </li>

                  <li>
                    <p className="TROUSParagraph">
                      Copyrighted images, videos, graphics, logos, trademarks, music,
                      text, or other materials used without the appropriate permission
                      or authorization.
                    </p>
                  </li>
                </ul>

                <strong className="TROUSStrong pt-2">
                  Campaign Information
                </strong>

                <p className="TROUSParagraph">
                  Campaign creators are responsible for providing complete and accurate
                  campaign information. This includes campaign titles, descriptions,
                  promotional messages, prices, discounts, offer details, start dates,
                  end dates, campaign images, and any applicable terms or conditions.
                </p>

                <p className="TROUSParagraph">
                  Campaign information should clearly communicate what is being
                  promoted and should not intentionally confuse or mislead customers.
                  Any restrictions or conditions associated with an offer should be
                  clearly stated within the campaign.
                </p>

                <strong className="TROUSStrong pt-2">
                  Campaign Images and Media
                </strong>

                <p className="TROUSParagraph">
                  Users may upload images, videos, graphics, logos, and other media
                  when creating campaigns. Users are responsible for ensuring that they
                  own the content or have the necessary rights and permissions to use it
                  for promotional purposes.
                </p>

                <p className="TROUSParagraph">
                  Campaign media should accurately represent the product, service, offer,
                  or business being promoted. Images or media should not intentionally
                  misrepresent the campaign or create false expectations for customers.
                </p>

                <strong className="TROUSStrong pt-2">
                  Pricing and Promotional Offers
                </strong>

                <p className="TROUSParagraph">
                  All prices, discounts, promotional amounts, and offer details entered
                  into BMT should be accurate and clearly communicated to customers.
                </p>

                <p className="TROUSParagraph">
                  Users must not create campaigns with fake discounts, misleading
                  original prices, hidden charges, or promotional conditions that are
                  intentionally difficult for customers to understand.
                </p>

                <p className="TROUSParagraph">
                  If a campaign has a limited availability period, the start and end
                  dates should accurately reflect the period during which the promotion
                  is available.
                </p>

                <strong className="TROUSStrong pt-2">
                  Campaign Publishing
                </strong>

                <p className="TROUSParagraph">
                  Users should review their campaign before publishing it through BMT.
                  Once published, campaign content may be visible to customers or
                  other intended audiences depending on the campaign targets.
                </p>

                <p className="TROUSParagraph">
                  Users are responsible for correcting campaign information that is
                  inaccurate, outdated, or no longer applicable.
                </p>

                <strong className="TROUSStrong pt-2">
                  Campaign Ownership and Responsibility
                </strong>

                <p className="TROUSParagraph">
                  The person or organization creating a campaign is responsible for the
                  content, claims, promotional information, media, pricing, and offers
                  included in that campaign.
                </p>

                <p className="TROUSParagraph">
                  BMT provides the tools and platform for campaign creation and
                  management but does not guarantee the accuracy of information supplied
                  by campaign creators.
                </p>

                <p className="TROUSParagraph">
                  Campaign creators should ensure that their campaigns comply with all
                  applicable laws, regulations, advertising requirements, and industry
                  standards that apply to their products, services, or business.
                </p>

                <strong className="TROUSStrong pt-2">
                  Campaign Review and Removal
                </strong>

                <p className="TROUSParagraph">
                  BMT reserves the right to review campaigns and promotional content
                  when necessary to maintain platform quality, protect users, investigate
                  complaints, or enforce these guidelines.
                </p>

                <p className="TROUSParagraph">
                  BMT may edit, restrict, suspend, or remove campaigns that violate these
                  guidelines or contain inaccurate, misleading, unauthorized, or
                  inappropriate promotional content.
                </p>

                <p className="TROUSParagraph">
                  Repeated or serious violations may result in restrictions or suspension
                  of the account responsible for creating or publishing the campaigns.
                </p>

                <strong className="TROUSStrong pt-2">
                  Campaign Quality
                </strong>

                <p className="TROUSParagraph">
                  BMT encourages users to create clear, professional, informative, and
                  engaging campaigns. Campaign titles, descriptions, images, offers,
                  pricing, and promotional messages should work together to provide
                  customers with an accurate understanding of the campaign.
                </p>

                <p className="TROUSParagraph">
                  Campaign content should be reviewed regularly to ensure that expired,
                  outdated, or unavailable offers are no longer presented as active
                  promotions.
                </p>

                <strong className="TROUSStrong pt-2">
                  Platform Integrity
                </strong>

                <p className="TROUSParagraph">
                  Users must not attempt to manipulate campaign performance, create
                  fraudulent campaigns, abuse promotional features, or use BMT campaign
                  tools in a way that could negatively affect the platform or other
                  users.
                </p>

                <p className="TROUSParagraph">
                  BMT may take appropriate action when campaign activity negatively
                  impacts platform integrity, customer experience, or the proper
                  operation of campaign services.
                </p>

                <p className="TROUSParagraph pt-2">
                  <strong className="TROUSStrong">Last Updated:</strong> August 17, 2026
                </p>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
